export const documentControlFeatureKey = 'document-control';

import { Action, combineReducers, createFeatureSelector } from '@ngrx/store';

import * as fromValidator from './reducers/validators/validators.reducer';

export interface DocumentControlState {
  [fromValidator.validatorsFeatureKey]: fromValidator.State;
}

export interface State {
  [documentControlFeatureKey]: DocumentControlState;
}

export const initialState: DocumentControlState = {
  [fromValidator.validatorsFeatureKey]: fromValidator.initialState,
};

export function reducers(
  state: DocumentControlState | undefined,
  action: Action,
) {
  return combineReducers({
    [fromValidator.validatorsFeatureKey]: fromValidator.reducer,
  })(state, action);
}

export const selectDocumentControlState =
  createFeatureSelector<DocumentControlState>(documentControlFeatureKey);
